<template>
  <div class="loader">
    <div class="container">
      <div class="spinner"></div>
      <div class="line-clamp-2">{{ text }}</div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['text']);
</script>
